import { memo, useState } from 'react';

import Button from 'components/field/Button';
import Popper from 'components/global/Popper';

import DynamicListMenu from './DynamicListMenu';
import * as S from './DynamicListMenu.styled';

/**
 * @author Burak Unsal
 */
const DynamicListRowMenu = (props) => {
	const { buttonIcon, menuItems, row, onClose } = props;

	const [buttonRef, setButtonRef] = useState(null);

	return (
		<>
			<Button
				id="rowMenuButton"
				ref={setButtonRef}
				css={S.ButtonCss}
				variant="borderless"
				icon={buttonIcon}
				iconButton
				size="small"
			/>

			{buttonRef && (
				<Popper refElement={buttonRef} placement="left-start">
					{(closePopper) => (
						<DynamicListMenu
							menuItems={menuItems}
							row={row}
							onClose={() => {
								onClose();
								closePopper();
							}}
							isRowMenu={true}
						/>
					)}
				</Popper>
			)}
		</>
	);
};

export default memo(DynamicListRowMenu);
